const { prepareTopPdp } = await import(document.querySelector('[data-top-pdp-module]')?.dataset.topPdpModule || new URL('./top-pdp-standard.js',import.meta.url).href);
const videoPlayer = () => import(document.querySelector('[data-pdp-video-player]')?.dataset.pdpVideoPlayer || new URL('./napoleon-ui.js',import.meta.url).href);
const template=document.getElementById('top-shared-brand-template');
function place(){
 const root=document.getElementById('outdoor-plus-root');
 if(!root?.querySelector('#configure')||root.querySelector('[data-top-initial]'))return;
 prepareTopPdp(root);
 const existing=document.querySelector('.top-brand-story');
 if(existing){
   if(existing.parentElement===root){const similar=root.querySelector('#fire-similar');if(similar&&existing.nextElementSibling!==similar)similar.before(existing);else if(!similar&&root.lastElementChild!==existing)root.append(existing);}
   return;
 }
 const fragment=template.content.cloneNode(true);
 root.append(fragment);
 const host=root.querySelector('.top-brand-story [data-napoleon-video]');
 if(host&&!host.dataset.videoMounted){host.dataset.videoMounted='true';videoPlayer().then(({mountPdpVideo})=>mountPdpVideo(host,{youtubeId:host.dataset.napoleonVideo,title:host.dataset.videoTitle,description:host.dataset.videoDescription}));}
}
if(template){place();new MutationObserver(place).observe(document.getElementById('MainContent'),{childList:true,subtree:true});}
